module.exports = __webpack_public_path__ + "media/images/arrow-right-black-b317b21a9b87e1a8a1217f4ca6bd343c.svg";